import { FaWhatsapp, FaInstagram, FaFacebookF } from "react-icons/fa";

const Footer = () => {
    return (
        <footer className="relative mt-12 overflow-hidden bg-zinc-950 text-white">
            <div
                className="pointer-events-none absolute inset-x-0 top-0 h-20"
                aria-hidden="true"
                style={{
                    background:
                        "linear-gradient(to bottom, rgba(9,9,11,0) 0%, rgba(9,9,11,0.88) 70%, rgba(9,9,11,1) 100%)",
                }}
            />
            <div
                className="pointer-events-none absolute inset-0 opacity-60"
                aria-hidden="true"
                style={{
                    background:
                        "radial-gradient(circle at 12% 85%, rgba(255, 74, 110, 0.11), transparent 36%), radial-gradient(circle at 90% 12%, rgba(59, 130, 246, 0.08), transparent 33%)",
                }}
            />
            <div className="relative mx-auto max-w-6xl px-4 pb-10 pt-12 sm:px-6">
                <div className="mb-8 flex flex-col items-start gap-2 text-left">
                    <img
                        src="/passeventBanner1.svg"
                        alt="PassEvent"
                        className="h-7 w-auto self-start"
                    />
                    <p className="max-w-2xl font-sans text-sm text-zinc-300">
                        Comprá tus entradas oficiales y accedé rápido a tus tickets digitales.
                    </p>
                </div>

                <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-12">
                    <div className="rounded-2xl border border-zinc-800 bg-zinc-900/55 p-5 backdrop-blur-sm lg:col-span-3">
                        <h4 className="mb-3 text-lg font-semibold">Contacto</h4>
                        <p className="mb-3 font-sans text-sm text-zinc-300">
                            Atención al cliente de 11:00 a 21:00 (solo WhatsApp):
                            <br />
                            +54 9 2355 55-0176
                        </p>
                        <a
                            href="https://api.whatsapp.com/send?phone=5492355550176&text=Hola%20vengo%20de%20PassEvent%20y%20mi%20consulta%20es..."
                            className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-r from-emerald-400 to-emerald-500 px-3 py-2 font-sans text-sm font-medium text-white shadow-[0_10px_22px_rgba(52,211,153,0.25)] transition-transform hover:scale-[1.02]"
                        >
                            <FaWhatsapp className="text-base" />
                            Escribir por WhatsApp
                        </a>
                    </div>

                    <div className="rounded-2xl border border-zinc-800 bg-zinc-900/55 p-5 backdrop-blur-sm lg:col-span-3">
                        <h4 className="mb-3 text-lg font-semibold">Redes</h4>
                        <div className="flex flex-wrap gap-2 font-sans text-sm text-zinc-300">
                            <a
                                href="https://www.instagram.com/passevent.ar/"
                                className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-r from-fuchsia-400 to-violet-500 px-3 py-2 font-medium text-white shadow-[0_10px_22px_rgba(192,132,252,0.25)] transition-transform hover:scale-[1.02]"
                            >
                                <FaInstagram />
                                Instagram
                            </a>
                            <a
                                href="https://www.facebook.com/share/15nVJ9Tf81/"
                                className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-r from-sky-400 to-blue-500 px-3 py-2 font-medium text-white shadow-[0_10px_22px_rgba(59,130,246,0.25)] transition-transform hover:scale-[1.02]"
                            >
                                <FaFacebookF />
                                Facebook
                            </a>
                        </div>
                    </div>

                    <div className="rounded-2xl border border-zinc-800 bg-zinc-900/55 p-5 backdrop-blur-sm lg:col-span-3">
                        <h4 className="mb-3 text-lg font-semibold">Productores</h4>
                        <a
                            href="https://producer.passevent.site"
                            className="inline-flex rounded-lg bg-gradient-to-r from-rose-500 to-rose-600 px-3 py-2 font-sans text-sm font-medium text-white shadow-[0_10px_22px_rgba(244,63,94,0.25)] transition-transform hover:scale-[1.02]"
                        >
                            Creá tu evento
                        </a>
                    </div>
                    <div className="rounded-2xl border border-zinc-800 bg-zinc-900/55 p-5 backdrop-blur-sm lg:col-span-3">
                        <h4 className="mb-3 text-lg font-semibold">Legales</h4>
                        <a
                            href="/terminos-y-condiciones.html"
                            className="block font-sans text-sm text-zinc-300 transition-colors hover:text-yellow-cdg"
                        >
                            Términos y condiciones
                        </a>
                        <a
                            href="/politica-de-privacidad.html"
                            className="mt-2 block font-sans text-sm text-zinc-300 transition-colors hover:text-yellow-cdg"
                        >
                            Políticas de privacidad
                        </a>
                    </div>

                    <div className="rounded-2xl border border-zinc-800 bg-zinc-900/55 p-5 text-center backdrop-blur-sm lg:col-span-12">
                        <h4 className="mb-3 text-lg font-semibold">Derechos</h4>
                        <p className="font-sans text-sm text-zinc-300">
                            &copy; {new Date().getFullYear()} PassEvent. Todos los derechos reservados.
                        </p>
                    </div>
                </div>

                <div className="mt-8 border-t border-zinc-800/70 pt-4 text-center font-sans text-xs text-zinc-500">
                    Hecho para conectar personas con eventos en todo momento.
                </div>
            </div>
        </footer>
    );
};

export default Footer;
